import styled, { css } from 'styled-components'
import { E_Colors } from '@/helpers/colors'

export const SC_MessagesLayout = styled.div<{ $isDesktop: boolean; $isTopicViewVisible: boolean }>`
  display: flex;
  gap: 1px;
  min-height: 0;
  height: 100%;
  width: 100%;
  background-color: ${E_Colors.GrayEB};
  border-radius: 12px;
  overflow: hidden;

  ${(p) => !p.$isDesktop && css`
    flex-direction: column;
    border-radius: 0;
  `}
`

export const SC_MessagesTopicsPane = styled.div<{ $isDesktop: boolean; $isTopicViewVisible: boolean }>`
  width: 100%;
  min-width: 0;
  background-color: ${E_Colors.White};
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;

  ${(p) => p.$isDesktop && css`
    width: 350px;
    min-width: 350px;
    flex-shrink: 0;
  `}

  ${(p) => !p.$isDesktop && p.$isTopicViewVisible && css`
    display: none;
  `}
`

export const SC_MessagesConversationPane = styled.div<{ $isDesktop: boolean; $isTopicViewVisible: boolean }>`
  width: 100%;
  min-width: 0;
  background-color: ${E_Colors.White};
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  ${(p) => p.$isDesktop && css`
    flex: 1;
  `}

  ${(p) => !p.$isDesktop && !p.$isTopicViewVisible && css`
    display: none;
  `}
`

export const SC_TopicSearchWrapper = styled.div`
  padding: 10px;
  border-bottom: 1px solid ${E_Colors.GrayF0};

  .ant-input-affix-wrapper {
    border: 0;
    border-radius: 10px;
    background-color: ${E_Colors.GrayF5F5F7};
    padding: 8px 12px;
    box-shadow: none;
  }

  .ant-input {
    font-size: 14px;
    background: transparent;
  }

  .ant-input::placeholder {
    color: ${E_Colors.Gray9C9CA1};
    text-align: center;
  }

  .ant-input-affix-wrapper-focused .ant-input::placeholder {
    text-align: left;
  }
`

export const SC_TopicList = styled.div`
  overflow-y: auto;
  min-height: 0;
`

export const SC_TopicItem = styled.button<{ $selected?: boolean }>`
  width: 100%;
  border: 0;
  background-color: ${(p) => (p.$selected ? E_Colors.PurpleWeak : E_Colors.White)};
  text-align: left;
  cursor: pointer;
  padding: 10px;
  border-bottom: 1px solid ${E_Colors.GrayF0};
  display: flex;
  align-items: center;
  gap: 10px;
`

export const SC_TopicItemAvatar = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: ${E_Colors.GrayF0};
  color: ${E_Colors.GrayA3};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const SC_TopicItemBody = styled.div`
  min-width: 0;
  width: 100%;
`

export const SC_TopicItemSubject = styled.div<{ $isUnread?: boolean }>`
  color: ${E_Colors.TextPrimary};
  font-size: 16px;
  font-weight: ${(p) => (p.$isUnread ? 600 : 400)};
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SC_TopicItemMeta = styled.div`
  color: ${E_Colors.Gray9C9CA1};
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

export const SC_UnreadDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${E_Colors.EraRed};
  flex-shrink: 0;
`

export const SC_TopicEmpty = styled.div`
  padding: 20px 12px;
  text-align: center;
  color: ${E_Colors.Gray9C9CA1};
  font-size: 13px;
`

export const SC_TopicHeaderMobile = styled.div`
  border-bottom: 1px solid ${E_Colors.GrayF0};
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
`

export const SC_BackButton = styled.button`
  border: 0;
  background: transparent;
  color: ${E_Colors.TextPrimary};
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  padding: 0;
`

export const SC_TopicHeaderTitle = styled.div`
  min-width: 0;

  > div:first-child {
    font-size: 14px;
    font-weight: 600;
    color: ${E_Colors.TextPrimary};
  }

  > div:last-child {
    margin-top: 2px;
    color: ${E_Colors.Gray9C9CA1};
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const SC_MessagesBody = styled.div`
  min-height: 0;
  overflow-y: auto;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background-color: ${E_Colors.White};
`

export const SC_MessageDateSeparator = styled.div`
  margin: 10px auto 6px;
  font-size: 12px;
  font-weight: 600;
  color: ${E_Colors.Gray9C9CA1};
  text-transform: uppercase;
`

export const SC_MessageRow = styled.div<{ $isMine?: boolean }>`
  display: flex;
  justify-content: ${(p) => (p.$isMine ? 'flex-end' : 'flex-start')};
`

export const SC_MessageBubble = styled.div<{ $isMine?: boolean }>`
  max-width: 75%;
  padding: 10px 14px;
  border-radius: 20px;
  background-color: ${(p) => (p.$isMine ? E_Colors.MainColorAccent : E_Colors.GrayF5F5F7)};
  color: ${(p) => (p.$isMine ? E_Colors.White : E_Colors.TextPrimary)};
  border-top-left-radius: ${(p) => (p.$isMine ? '20px' : '2px')};
  border-bottom-left-radius: ${(p) => (p.$isMine ? '20px' : '2px')};
  border-top-right-radius: ${(p) => (p.$isMine ? '2px' : '20px')};
  border-bottom-right-radius: ${(p) => (p.$isMine ? '2px' : '20px')};
`

export const SC_MessageAuthor = styled.div<{ $isMine?: boolean }>`
  font-size: 12px;
  margin-bottom: 2px;
  color: ${(p) => (p.$isMine ? E_Colors.Pink : E_Colors.Gray66)};
`

export const SC_MessageText = styled.div`
  font-size: 14px;
  white-space: pre-wrap;
  word-break: break-word;
`

export const SC_MessageTime = styled.div<{ $isMine?: boolean }>`
  margin-top: 4px;
  font-size: 11px;
  text-align: right;
  color: ${(p) => (p.$isMine ? E_Colors.Pink : E_Colors.Gray9C9CA1)};
`

export const SC_MessageFiles = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const SC_MessageFileLink = styled.a<{ $isMine?: boolean }>`
  color: ${(p) => (p.$isMine ? E_Colors.White : E_Colors.MainColorAccent)};
  text-decoration: none;
  font-size: 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

export const SC_Composer = styled.div`
  border-top: 1px solid ${E_Colors.GrayF0};
  padding: 8px 10px 10px;
  background-color: ${E_Colors.White};
`

export const SC_ComposerRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
`

export const SC_AttachButton = styled.button`
  border: 0;
  color: ${E_Colors.Gray88};
  background: transparent;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const SC_SendButton = styled.button`
  border: 0;
  background-color: ${E_Colors.MainColorAccent};
  color: ${E_Colors.White};
  border-radius: 10px;
  height: 40px;
  min-width: 40px;
  cursor: pointer;
  padding: 0 12px;
`

export const SC_ComposerInputWrapper = styled.div`
  flex: 1;
  border-bottom: 1px solid ${E_Colors.GrayCC};
  min-width: 0;

  .ant-input {
    border: 0;
    box-shadow: none;
    resize: none;
    padding: 0 0 4px;
    border-radius: 0;
  }
`

export const SC_SystemMessageNote = styled.div`
  color: ${E_Colors.TextPrimary};
  font-size: 16px;
  line-height: 1.3;
`

export const SC_AttachmentsHint = styled.div`
  margin-top: 6px;
  color: ${E_Colors.Gray9C9CA1};
  font-size: 12px;
`

export const SC_AttachmentsList = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const SC_AttachmentItem = styled.div`
  border-radius: 10px;
  border: 1px solid ${E_Colors.GrayEB};
  background-color: ${E_Colors.GrayF5F5F7};
  padding: 6px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

export const SC_AttachmentInfo = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const SC_AttachmentName = styled.div`
  font-size: 12px;
  color: ${E_Colors.TextPrimary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SC_AttachmentMeta = styled.div`
  font-size: 11px;
  color: ${E_Colors.Gray9C9CA1};
`

export const SC_AttachmentRemoveButton = styled.button`
  border: 0;
  background: transparent;
  color: ${E_Colors.EraRed};
  cursor: pointer;
`

export const SC_EmptyMessages = styled.div`
  margin: auto;
  color: ${E_Colors.Gray9C9CA1};
  font-size: 13px;
  text-align: center;
  padding: 16px;
`
